import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-navbar-scrollable-dropdown',
  templateUrl: './navbar-scrollable-dropdown.component.html',
  styleUrls: ['./navbar-scrollable-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NavbarScrollableDropdownComponent {
}
